/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { ApplyPanelDataComponent } from "../../components/detailing/apply-panel-data/apply-panel-data.component";
import { SysquePopupConfig } from "../../models/sysque-popup-config";
import { PopupDialog } from "../popup-dialog.interface";

export class PanelDialog implements PopupDialog {

  create(sysquePopupConfig: SysquePopupConfig): any {
    sysquePopupConfig.component = ApplyPanelDataComponent;
    sysquePopupConfig.data =[];
    (sysquePopupConfig.data as string[]) = [ "project1", "project2", "project3" ];
    sysquePopupConfig.component.data = sysquePopupConfig.data
    sysquePopupConfig.width = 613;
    sysquePopupConfig.height = 450;
    sysquePopupConfig.componentTitle = "Apply Panel / Circuit ID";
  }

}